<template>
  <div>
    <el-alert
      :closable="false"
      title="Ha módosítasz egy bizonylatelőtagot, akkor a múltbeli bizonylatok nem fognak változni. Az évszám automatikusan illesztődik be a bizonylatszámba."
      type="info"
      show-icon
      style="margin-bottom: 20px;"
    />
    <div
      v-loading="loading"
      class="receipt-prefixes"
    >
      <el-row
        v-if="receiptSettings"
        :gutter="20"
      >
        <el-form>
          <el-col
            v-for="setting in receiptSettings"
            :key="setting.type"
            :span="6"
          >
            <el-form-item
              :label="getLabel(setting.type)"
            >
              <el-input
                :key="`${setting.type}-input`"
                v-model="setting.prefix"
              />
              <div class="help-text">
                Minta bizonylatszám: {{ setting.prefix }}/{{ (new Date()).getFullYear() }}/{{ (parseInt(Math.random() * 1000)) }}
              </div>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableKey: 0,
      receiptSettings: null,
      types: {
        customerOrder: 'Vevői megrendelés előtag',
        customerProformOrder: 'Proforma előtag',
        customerReturnOrder: 'Vevői visszáru előtag',
        customerSale: 'Vevői eladás előtag',
        declutter: 'Selejtezés előtag',
        inwardHandling: 'Bevételezés előtag',
        representativeDelivery: 'Raktárközi szállitólevél előtag',
        representativeDrop: 'Képviselői leadás előtag',
        representativeInwardHandling: 'Raktárközi bevételezés előtag',
        representativeOrder: 'Raktárközi megrendelés előtag',
        representativePlacement: 'Képviselői kihelyezés előtag',
        representativeReceive: 'Képviselői átvétel előtag',
        representativeSaleCash: 'Képviselői készpénzes eladás előtag',
        representativeSaleTransfer: 'Képviselői átutalásos eladás előtag',
        representativeTransfer: 'Képviselői átadás előtag',
        stockTaking: 'Leltár előtag',
        stowage: 'Rakodási előtag',
        supplierOrder: 'Szállítói megrendelés előtag',
        supplierReturnOrder: 'Beszállítói visszáru előtag',
      },
    };
  },
  computed: {
    loading() {
      return this.$store.getters['receiptSetting/loading'];
    },
  },
  async mounted() {
    this.receiptSettings = await this.$store.dispatch('receiptSetting/fetchAll');
  },
  methods: {
    getLabel(type) {
      return this.types[type];
    },
  },
};
</script>

<style lang="scss">
  .receipt-prefixes {
    .el-form-item {
      margin-bottom: 5px;
      .help-text {
        color: #9d9fa2;
        font-style: italic;
        max-width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        line-height: 2.5;
      }
    }
  }
</style>
